import React from 'react';

import Box from '@amzn/meridian/box';
import Input from '@amzn/meridian/input';
import Text from '@amzn/meridian/text';
import { type MeasureUnitValues } from 'src/services/tasks/constants';

// **** Types **** //

interface DurationProps {
  value: number | undefined;
  measureUnit: MeasureUnitValues;
  onChange: (value: number) => void;
  isDisabled: boolean;
  errorMessage: string | undefined;
  /** @testOnly */
  index: number;
}

// **** Components **** //

/**
 * Select hours value available based on the shift length.
 */
const DurationSelector = ({ value, onChange: onChange, isDisabled, errorMessage, index }: DurationProps) => {
  return (
    <Box>
      <Text data-testid="new-jmr__time-limitation-field-label">Duration (minutes)</Text>
      <Input
        aria-label="Duration (minutes)"
        data-cy={`new-jmr__limitations__duration-selector__${index}`}
        type="number"
        placeholder="Enter duration in minutes (i.e. 15)"
        value={value}
        onChange={(val) => {
          if (+val >= 0) onChange(val);
        }}
        errorMessage={errorMessage}
        error={!!errorMessage}
        disabled={isDisabled}
      />
    </Box>
  );
};

// **** Export **** //

export default DurationSelector;
